// Навигация по полуходам текущей попытки тренажёра зевков (чистая, без DOM,
// покрыта vitest). Кадр 0 — позиция задачи; ход юзера и ответы бота при
// доигрывании добавляются в хвост. Кнопки ◀ ▶ листают, всегда можно вернуться
// к задаче (toStart), не стирая записанную линию.

export interface Frame {
  fen: string;
  last: { from: string; to: string } | null;
}

export class AttemptNav {
  private frames: Frame[];
  private cursor = 0;

  constructor(taskFen: string) {
    this.frames = [{ fen: taskFen, last: null }];
  }

  /** Сброс к новой задаче: единственный кадр — её позиция. */
  reset(taskFen: string): void {
    this.frames = [{ fen: taskFen, last: null }];
    this.cursor = 0;
  }

  /** Добавить кадр в хвост, обрезав ветку вперёд от курсора; курсор → на новый. */
  push(fen: string, last: Frame['last']): void {
    this.frames.length = this.cursor + 1;
    this.frames.push({ fen, last });
    this.cursor = this.frames.length - 1;
  }

  back(): Frame {
    if (this.cursor > 0) this.cursor--;
    return this.current();
  }

  forward(): Frame {
    if (this.cursor < this.frames.length - 1) this.cursor++;
    return this.current();
  }

  /** Курсор на кадр 0 (позиция задачи) без стирания хвоста. */
  toStart(): Frame {
    this.cursor = 0;
    return this.current();
  }

  current(): Frame {
    return this.frames[this.cursor]!;
  }

  get onTask(): boolean {
    return this.cursor === 0;
  }

  get canBack(): boolean {
    return this.cursor > 0;
  }

  get canForward(): boolean {
    return this.cursor < this.frames.length - 1;
  }
}
